module.exports = __webpack_public_path__ + "static/media/goLive.a7c287b0.png";